import * as Paginator from "react-bootstrap-table2-paginator";

import { Card, Col, Form, Row } from "react-bootstrap";
import { Field, Formik } from "formik";
import React, { useEffect, useState } from "react";
import ToolkitProvider, {
  CSVExport,
  Search,
} from "react-bootstrap-table2-toolkit";
import {
  faPlus,
  faSearch,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import {
  getCustomerDDFDispatchR,
  getCustomerWiseDispatch,
} from "../../Service/AllReportAPI";
import {
  getDispatchEntryByDate,
  getDispatchPdfDownload,
} from "../../Service/AllDispatchAPI";

import Axios from "../../utils/axiosInstance";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import Pagination from "react-bootstrap-table2-paginator";
import Select from "react-select";
import Table from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
import fileSaver from "file-saver";
import { getDispatchList } from "../../Service/AllDispatchAPI";
import moment from "moment";
import swal from "sweetalert";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

//import * as Yup from "yup";

export default () => {
  const { SearchBar } = Search;
  const [entries, setEntries] = useState([]);
  const { ExportCSVButton } = CSVExport;
  const selectRow = {
    mode: "checkbox",
  };
  const [changeRowData, setChangeRowData] = useState({
    selectedRow: [],
    cellChange: "",
    columnChange: [],
  });

  const [customerName, setCustomerName] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  let role = sessionStorage.getItem("role");
  const [isLoaded, setisLoaded] = useState(false);

  // --- pagination
  const [state, setState] = useState({});
  const [currentPage, setcurrentPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [totaloffset, setTotaloffset] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  const handlePageChange = async (page) => {
    setEntries([]);
    const selectedPage = page - 1;
    console.log("selectedPage", selectedPage);
    if (selectedCustomer === "") {
      const role = sessionStorage.getItem("role");
      const fkUserId = sessionStorage.getItem("pkUserId");
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      // setisLoaded(true);
      await getDispatchList(selectedPage, fkUserId, role, headers)
        .then((result) => {
          console.log("Get Pagination Dispatch Result", result);
          if (result?.data?.content?.length !== 0) {
            const data = result.data.content;
            const totalSize = result.data.pageable.offset;
            console.log("data", data);
            setEntries(data);
            setPageCount(result.data.totalPages);
            setTotaloffset(totalSize);
            entries.map((item, index) => (item.id = totalSize + index + 1));
            // setisLoaded(false);
          } else {
            // setisLoaded(false);
            swal("Sorry", "Data is not present", "warning");
          }
        })
        .catch((error) => console.error("Error", error));
    } else if (selectedCustomer !== "") {
      // setisLoaded(true);
      await getCustomerWiseDispatch(selectedPage, selectedCustomer)
        .then((result) => {
          console.log("Get Pagination customer wise Dispatch Result", result);
          if (result?.data?.content?.length !== 0) {
            const data = result.data.content;
            const totalSize = result.data.pageable.offset;
            entries.map((item, index) => (item.id = totalSize + index + 1));
            console.log("totalSize", totalSize);
            console.log("data", data);
            setEntries(data);
            setTotaloffset(totalSize);
            setTotalCount(result.data.totalElements);
            // setisLoaded(false);
          } else {
            // setisLoaded(false);
            swal("Sorry", "Data is not present", "warning");
          }
        })
        .catch((error) => {
          console.log("Get Field Issue Error", error);
        });
    } else {
      swal("Failed", "Please select date", "error");
    }
  };

  useEffect(() => {
    // Function call to get Dispatch list
    getDispatch();
    getCustomerDDFDispatchRList();
  }, []);

  const getDispatch = async () => {
    try {
      const role = sessionStorage.getItem("role");
      const fkUserId = sessionStorage.getItem("pkUserId");
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      setisLoaded(true);
      await getDispatchList(currentPage, fkUserId, role, headers)
        .then((result) => {
          setisLoaded(false);
          console.log("Get Dispatch Result", result);
          if (result?.data?.content?.length !== 0) {
            const data = result.data.content;
            setEntries(data);
            setPageCount(result.data.totalPages);
            setTotalCount(result.data.totalElements);
          } else {
            setEntries([]);
            setPageCount();
            setTotalCount();
          }
        })
        .catch((error) => {
          console.log("Get Dispatch Error", error);
        });
    } catch (error) {
      console.log(error);
      swal(
        "Failed",
        "Something went wrong please check your internet",
        "error"
      );
    }
  };

  const getCustomerDDFDispatchRList = async () => {
    let token = sessionStorage.getItem("token");
    let headers = { Authorization: `Bearer ${token}` };
    await getCustomerDDFDispatchR(headers)
      .then((result) => {
        console.log("getCustomerDDFDispatchRList result :-", result);
        let customerDD = [];
        let tempCustomerDDArray = result.data.map((obj) => {
          let customer = obj.split(",");
          return {
            id: `${customer[0]}`,
            value: `${customer[1]}`,
            label: `${customer[1]}`,
          };
        });
        customerDD = tempCustomerDDArray;
        setCustomerName(customerDD);
        console.log("getCustomerDDFDDispatchRList customerDD", customerDD);
      })
      .catch((error) => {
        console.log("getDealerDDFWorkOrderRList error :-", error);
      });
  };

  // const getDispatchListByFromDate = (e) => {
  //   setFromDate(e.target.value);
  //   console.log(fromDate);
  //   if (e.target.value > new Date().toISOString().split("T")[0]) {
  //     swal("Sorry", "Please select today or day before today", "warning");
  //   }
  // };

  // const getDispatchListByToDate = async (e) => {
  //   setToDate(e.target.value);
  //   console.log(toDate);
  //   if (e.target.value > new Date().toISOString().split("T")[0]) {
  //     swal("Sorry", "Please select today or day before today", "warning");
  //   }
  // };
  const handleFromDateChange = (date) => {
    setFromDate(date);
    // Clear the "To" date if it's before the selected "From" date
    if (toDate && date > toDate) {
      setToDate(null);
    }
  };

  const handleToDateChange = (date) => {
    if (date < fromDate) {
      swal('Invalid Date', 'The "To" date cannot be before the "From" date.', 'warning');
      setToDate(null); // Reset "To" date if invalid
    } else {
      setToDate(date);
    }
  };

  const getDispatchByDate = async () => {
    try {
      setTimeout(async () => {
        setisLoaded(true);
        if (fromDate !== "" && toDate !== "") {
          await getDispatchEntryByDate(
            currentPage,
            moment(fromDate).format("yyyy-MM-DD"),
            moment(toDate).format("yyyy-MM-DD")
          )
            .then((result) => {
              setisLoaded(false);
              console.log("Get Production Entry Result", result);
              if (result?.data?.content?.length !== 0) {
                const data = result.data.content;
                setEntries(data);
                setPageCount(result.data.totalPages);
                setTotalCount(result.data.totalElements);
              } else {
                setEntries([]);
                setPageCount();
                setTotalCount();
                swal("Sorry", "Data is not present", "warning");
              }
              // console.log("setNoOfElements", noOfElements);
            })
            .catch((error) => {
              console.log("Get Production Error", error);
            });
        } else {
          swal("Failed", "Please select date", "error");
        }
      }, 200);
    } catch (error) {
      console.log(error);
      swal(
        "Failed",
        "Something went wrong please check your internet",
        "error"
      );
    }
  };

  const getCustomerWiseDispatchPdf = async (e) => {
    if (selectedCustomer !== "") {
      try {
        setisLoaded(true);
        let token = sessionStorage.getItem("token");
        let fileType = ["Pdf"];
        let role = sessionStorage.getItem("role");
        let fkUserId = sessionStorage.getItem("pkUserId");
        return Axios.get(
          `getCustomerNameWiseDispatchReportPdf?fileType=${fileType}&customerName=${selectedCustomer}&fkUserId=${fkUserId}&role=${role}`,
          {
            headers: { Authorization: `Bearer ${token}` },
            responseType: "arraybuffer",
          }
        ).then((response) => {
          var blob = new Blob([response.data], { type: "application/pdf" });
          fileSaver.saveAs(blob, `customernamewisedispatchreport.pdf`);
          setisLoaded(false);
        });
      } catch (error) {
        setisLoaded(false);
        console.log(error);
        swal(
          "Failed",
          "Something went wrong please check your internet",
          "error"
        );
      }
    } else if (role === "customer") {
      try {
        if (fromDate !== "" && toDate !== "") {
          setisLoaded(true);
          await getDispatchPdfDownload(
            moment(fromDate).format("yyyy-MM-DD"),
            moment(toDate).format("yyyy-MM-DD")
          );
          setisLoaded(false);
        } else {
          swal("Failed", "Please select date", "warning");
        }
      } catch (error) {
        setisLoaded(false);
        console.log(error);
        swal(
          "Failed",
          "Something went wrong please check your internet",
          "error"
        );
      }
    } else {
      swal("Failed", "Please Select Customer Name", "error");
    }
  };

  const getCustomerWiseDispatchExcel = async (e) => {
    try {
      if (selectedCustomer !== "") {
        let token = sessionStorage.getItem("token");
        let fileType = ["Excel"];
        let role = sessionStorage.getItem("role");
        let fkUserId = sessionStorage.getItem("pkUserId");
        return Axios.get(
          `getCustomerNameWiseDispatchReportPdf?fileType=${fileType}&role=${role}&fkUserId=${fkUserId}&customerName=${selectedCustomer}`,
          {
            headers: { Authorization: `Bearer ${token}` },
            responseType: "arraybuffer",
          }
        ).then((result) => {
          let blob = new Blob([result.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          fileSaver.saveAs(blob, "customernamewisedispatchreportexcel.xlsx");
        });
      } else {
        swal("Failed", "Please Select Customer Name", "warning");
      }
    } catch (error) {
      console.log("getCustomerWiseDispatchExcel error :-", error);
      swal(
        "Failed",
        "Something went wrong please check your internet",
        "error"
      );
    }
  };

  // Adding srno column to list
  entries.map((item, index) => (item.id = totaloffset + index + 1));
  // Column heading of Customer list
  const columns = [
    { dataField: "id", text: "Id" },
    {
      dataField: "workOrderNo",
      text: "Work Order No",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "customerFullName",
      text: "Customer Name",
      editable: false,
      headerAlign: "left",
    },
    // {
    //   dataField: "dealerName",
    //   text: "Dealer Name",
    //   editable: false,
    //   headerAlign: "left",
    // },
    {
      dataField: "vehicleNo",
      text: "Vehicle No",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "driverName",
      text: "Driver Name",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "driverContactNo",
      text: "Driver Contact No",
      editable: false,
      headerAlign: "left",
    },
    // {
    //   dataField: "dispatchType",
    //   text: "Dispatch Type",
    //   editable: false,
    //   headerAlign: "left",
    // },
    {
      dataField: "generateUniqueDispenserNo",
      text: "Dispenser No",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "modelName",
      text: "Dispenser Type",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "dispatchDate",
      text: "Dispatch Date",
      editable: false,
      headerAlign: "left",
      formatter: (cell) => {
        return <>{moment(cell).format("DD-MMM-YYYY")}</>;
      },
    },
    {
      dataField: "dispatchTime",
      text: "Dispatch Time",
      editable: false,
      headerAlign: "left",
      formatter: (cell) => {
        return <>{moment(cell, "hh:mm A").format("hh:mm A")}</>;
      },
    },
    {
      dataField: "whoDidIt",
      text: "WO Created User Name",
      editable: false,
      headerAlign: "left",
    },
  ];

  // custom the pagination total
  const customTotal = (from, to, size) => (
    <div>
      Showing {totaloffset + from} to {totaloffset + to} of {size} entries
    </div>
  );
  // callback function when page was changing
  const customSizePerPage = (props) => {
    const { options, currentSizePerPage, onSizePerPageChange } = props;
    const onPageChange = (e) => {
      const page = e.target.value;
      onSizePerPageChange(page);
    };

    return (
      <>
        <Row>
          <Col xs="auto">
            <Form.Select
              value={currentSizePerPage}
              onChange={onPageChange}
              className="pe-5"
            >
              {options.map((o) => (
                <option key={o.page} value={o.page}>
                  {o.text}
                </option>
              ))}
            </Form.Select>
          </Col>
          <Col xs="auto" className="d-flex align-items-center">
            Entries per page
          </Col>
        </Row>
      </>
    );
  };

  return (
    <>
      {isLoaded ? (
        <div className="reportload"></div>
      ) : (
        <>
          {role === "dealer" ? (
            <>
              <Row>
                <Col md={3} className="mb-3">
                <div className="form-group">
                <label>From Date</label>
                <DatePicker
                  selected={fromDate}
                  onChange={handleFromDateChange}
                  dateFormat="dd-MMM-yyyy"
                  maxDate={new Date()}
                  className="form-control"
                  placeholderText="DD-MMM-YYYY"
                  showYearDropdown
                  scrollableYearDropdown
                />
              </div>
                </Col>
                <Col md={3} className="mb-3">
                <div className="form-group">
                <label>To Date</label>
                <DatePicker
                  selected={toDate}
                  onChange={handleToDateChange}
                  dateFormat="dd-MMM-yyyy"
                  minDate={fromDate}
                  maxDate={new Date()}
                  className="form-control"
                  placeholderText="DD-MMM-YYYY"
                  showYearDropdown
                  scrollableYearDropdown
                />
              </div>
                </Col>
                <Col md={4} className="mb-3">
                  <button
                    className="btn btn-secondary mt-lg-4"
                    onClick={getDispatchByDate}
                  >
                    <FontAwesomeIcon icon={faSearch} className="me-2" />
                    <span>Search By Date</span>{" "}
                  </button>
                </Col>
              </Row>
            </>
          ) : (
            ""
          )}

          <Formik
            initialValues={{}}
            onSubmit={async (values) => {
              console.log(JSON.stringify(values, null, 2));
            }}
          >
            {(formik) => {
              return (
                <>
                  <Row>
                    <Col md={6} className="mb-3">
                      <div className="form-group">
                        <label className="Label mb-1">Customer Name</label>
                        <Select
                          id="customerFullName"
                          placeholder="Select Customer Name"
                          title="Select Customer Name"
                          options={customerName}
                          onChange={async (e) => {
                            formik.setFieldValue("customerFullName", e.value);
                            setSelectedCustomer(e.value);
                            // setisLoaded(true);   //sab made changes for not to reload selected name 
                            await getCustomerWiseDispatch(currentPage, e.value)
                              .then((result) => {
                                console.log(
                                  "Customer Dispatch Details",
                                  result.data
                                );
                                if (result?.data?.content?.length !== 0) {
                                  const data = result.data.content;
                                  setEntries(data);
                                  setPageCount(result.data.totalPages);
                                  setTotalCount(result.data.totalElements);
                                  setisLoaded(false);
                                } else {
                                  setEntries([]);
                                  setPageCount();
                                  setTotalCount();
                                  setisLoaded(false);
                                  swal(
                                    "Sorry",
                                    "Data is not present",
                                    "warning"
                                  );
                                }
                              })
                              .catch((error) => {
                                console.log("Dispatch Error", error);
                              });
                          }}
                        />
                      </div>
                    </Col>
                  </Row>
                  {/* --- When you use any toolkit functionalities, you are supposed to render toolkit component and
  BootstrapTable as the children of ToolkitProvider --- */}
                  <ToolkitProvider
                    keyField="id"
                    search={true}
                    columns={columns}
                    data={entries}
                    exportCSV={{ onlyExportFiltered: true, exportAll: false }}
                  >
                    {({ baseProps, searchProps, csvProps }) => (
                      //render the Pagination component as a list with left and right arrows
                      <Paginator.PaginationProvider
                        pagination={Pagination({
                          custom: true,
                          disablePageTitle: true,
                          alwaysShowAllBtns: true,
                          totalSize: totalCount,
                          paginationTotalRenderer: customTotal,
                          onPageChange: handlePageChange,
                        })}
                      >
                        {({ paginationProps, paginationTableProps }) => (
                          <Card>
                            <div className="table-responsive py-2">
                              <Card.Header>
                                <Row>
                                  <Col xs={12} md={6} className="py-1">
                                    {/* <Paginator.SizePerPageDropdownStandalone
                                      {...paginationProps}
                                    /> */}
                                  </Col>
                                  <Col
                                    xs={12}
                                    md={6}
                                    className="d-flex justify-content-md-end py-1"
                                  >
                                    <button
                                      className="btn btn-secondary mx-2"
                                      onClick={getCustomerWiseDispatchPdf}
                                    >
                                      <FontAwesomeIcon
                                        icon={faDownload}
                                        className="me-2"
                                      />
                                      <span>PDF</span>{" "}
                                    </button>
                                    <button
                                      className="btn btn-secondary"
                                      onClick={getCustomerWiseDispatchExcel}
                                    >
                                      <FontAwesomeIcon
                                        icon={faDownload}
                                        className="me-2"
                                      />
                                      <span>Excel</span>
                                    </button>
                                  </Col>
                                </Row>
                              </Card.Header>
                              <Table
                                {...baseProps}
                                {...paginationTableProps}
                                bodyClasses="border-0"
                                rowClasses="border-bottom"
                                classes="table-flush dataTable-table"
                                filter={filterFactory()}
                                headerClasses="header-class"
                                hover
                                striped
                                remote={{ pagination: true }}
                                cellEdit={cellEditFactory({
                                  mode: "click",
                                  blurToSave: true,
                                  afterSaveCell: (
                                    oldValue,
                                    newValue,
                                    row,
                                    column
                                  ) => {
                                    const changeRowData = {
                                      selectedRow: row,
                                      cellChange: newValue,
                                      columnChange: column,
                                    };
                                    setChangeRowData(changeRowData);
                                  },
                                })}
                                wrapperClasses="table-responsive"
                              />
                              <Card.Footer>
                                <Row>
                                  <Col
                                    xs={12}
                                    md={6}
                                    className="d-flex align-items-center py-1"
                                  >
                                    {/* <Paginator.PaginationTotalStandalone
                              {...paginationProps}
                            /> */}
                                  </Col>
                                  <Col
                                    xs={12}
                                    md={6}
                                    className="d-flex justify-content-md-end align-items-center mb-0 py-1"
                                  >
                                    <Paginator.PaginationListStandalone
                                      {...paginationProps}
                                    />
                                  </Col>
                                </Row>
                              </Card.Footer>
                            </div>
                          </Card>
                        )}
                      </Paginator.PaginationProvider>
                    )}
                  </ToolkitProvider>
                </>
              );
            }}
          </Formik>
        </>
      )}
    </>
  );
};
// }};
